export enum PageEnum {
  DES_PAGE = 'desPage',
  PAGE_TYPE='pageType',
  //登录类型
  LOGIN_USER_TYPE='loginUserType',
  SYSTEM_PROJECT_PRE='xmSystemProject_',
  //显示类型
  SHOW_TYPE='showType',
  //系统属性
  PAGE_CTLS = 'pageCtls',
  //运行态应用
  RUNNING_APP='runningApp',
  APP_SHOW='appShow',
  TEMPLATE_ID='templateId',
  APP_ID='appId',
  //门户设计
  MAIN_PAGE_DES = 'mainPageDes',
  //系统属性
  SYSTEM_PROP_STATE = 'systemProp',
  //普通界面设计
  COMMON_PAGE = 'commonPage',
  //应用界面设计
  APP_PAGE = 'pageDes',
  //空表达式
  EMPTY_FORMULA='{}',
  ISUSER = '1',
  // basic login path
  BASE_LOGIN = '/login',
  // basic home path
  BASE_HOME = '/dashboard',
  // basic home url
  BASE_HOME_URL = '/dashboard/analysis',
  BASE_APP_MAIN_URL = '/openAppMainPage',
  // error page path
  ERROR_PAGE = '/exception',
  // error log page path
  ERROR_LOG_PAGE = '/error-log/list',
}
